<template>
  <div id="sms">
    <transition-group name="fade01" mode="out-in">
      <el-card class="box-card" key="sms">
        <div slot="header" class="clearfix">
          <span>
            <i class="el-icon-bank-card"></i>
            ご本人確認をSMS認証を行うため電話番号と会員の方は生年月日をご入力ください
          </span>
        </div>
        <div class="text item">
          <div class="cregit_form">
            <p class="send_error_message" v-if="sms.send_error_message">
              <el-alert :title="sms.send_error_message" effect="dark" :closable="false" type="error"> </el-alert>
            </p>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-input
                  id="tel"
                  name="tel"
                  placeholder="SMS"
                  v-model="sms.val"
                  type="tel"
                  maxlength="11"
                  @input="smsInput"
                ></el-input>
              </el-col>
              <el-col :span="7">
                <el-input
                  id="birthday"
                  name="birthday"
                  placeholder="生年月日の入力"
                  v-model="birthday_num"
                  maxlength="8"
                  type="tel"
                ></el-input>
              </el-col>
              <el-col :span="5">
                <div class="button_area">
                  <el-button
                    id="smsSend"
                    type="primary"
                    icon="el-icon-arrow-right"
                    @click="handleCooperate"
                    :disabled="disabledButton"
                    :loading="smsSendButtonLoading"
                    >SMSを送信</el-button
                  >
                </div>
              </el-col>
            </el-row>
            <p class="input_sample">電話番号のご入力例 必ず11桁以上の数字でご入力ください「08078924512」</p>
            <p class="input_sample">生年月日のご入力例 1986年05月16日生まれの場合「19860516」</p>
          </div>
        </div>
      </el-card>
    </transition-group>

    <el-dialog :visible.sync="sms.dialog" width="400px" :close-on-click-modal="false">
      <div class="sms">
        <h2 class="sms__ttl"><i class="el-icon-lock sms__icon"></i> 認証コード入力</h2>
        <p class="sms__txt">届いた4桁のコードを入力してください。</p>
        <p class="error_message" v-if="sms.error_message">
          <el-alert :title="sms.error_message" effect="dark" :closable="false" type="error"> </el-alert>
        </p>
        <el-input id="code" name="code" type="tel" v-model="sms.code" maxlength="4" @input="inputCheck" show-word-limit>
        </el-input>
        <el-button id="codeSend" type="primary" class="sms__btn" :disabled="disabledCodeButton" @click="checkCode"
          >送信</el-button
        >
        <el-divider />
        <el-button type="text" class="skip__btn" :disabled="disabledSkipButton" @click="skipCheckCode"
          >認証コードが届かない方はこちら</el-button
        >
        <p class="skip__txt" v-if="getHasPayment === 'credit'">
          認証コードが届かない場合、お客様の携帯電話にトリプルクラウンから本人確認電話をさせていただきます。
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getFormatPhone} from '@/js/util/helper'
import {
  TransUserInputFromWebApi,
  TransUploadInputFromWebApi,
  TransUserInputFromTfic,
  TransUploadInputFromTfic
} from '@/js/util/member/formDataTransform'
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'newuser',
  components: {},
  data() {
    return {
      sms: {
        send: false,
        val: '',
        dialog: false,
        code: '',
        error_message: '',
        send_error_message: ''
      },
      next: false,
      sms_count: 0,
      birthday_num: null,
      channel: null,
      isChatchedCustomerData: false,
      requestTficCount: 0,
      requestTficLimit: 10,
      requestTficIntervalId: null,
      smsSendButtonLoading: false
    }
  },
  computed: {
    disabledButton() {
      if (this.sms.send && this.birthday_num) {
        return false
      } else {
        return true
      }
    },
    disabledCodeButton() {
      const tficConnected = this.isChatchedCustomerData || this.requestTficCount >= this.requestTficLimit
      if (this.sms.code !== '' && tficConnected) {
        return false
      }
      return true
    },
    disabledSkipButton() {
      return !(this.isChatchedCustomerData || this.requestTficCount >= this.requestTficLimit)
    },
    ...mapGetters({
      getHasPayment: 'status/getHasPayment',
      user: 'auth/user',
      uploadInputGetForm: 'uploads/getForm'
    })
  },
  created() {
    history.pushState(null, null, null)
    window.addEventListener('popstate', this.handleBlowserBack)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handleBlowserBack)
  },
  mounted() {
    // ページ名を上に伝達
    this.$emit('page', 'form-sms')
    this.updateHasDoneSms(false)

    // 初期化
    this.$store.commit('customer/delete')
  },
  methods: {
    handleBlowserBack() {
      history.pushState(null, null, null)
      alert('商品入力画面には戻ることができません。')
    },
    smsInput(val) {
      this.sms.val = this.sms.val.replace(/[^0-9]/g, '')
      if (getFormatPhone(this.sms.val) && this.sms.val.length == 11) {
        this.sms.send = true
      } else {
        this.sms.send = false
      }
    },
    inputCheck(val) {
      this.sms.code = this.sms.code.replace(/[^0-9]/g, '')
    },
    async handleCooperate() {
      // 送信処理中は処理させない
      if(this.smsSendButtonLoading){
        return
      }

      this.sms.send_error_message = '' // エラーメッセージ削除
      this.isChatchedCustomerData = false
      this.requestTficCount = 0
      this.smsSendButtonLoading = true

      const data = await this.sendSms(this.sms.val, this.birthday_num, this.getHasPayment).catch((err) => {
        this.sms.send_error_message = err
      })

      this.smsSendButtonLoading = false

      if (!data) return

      // Pusher待機
      Echo.private(`store.${this.user.store_user_id}.member.${this.user.id}.form-customer-user.${data.id}`).listen(
        '.mydata-catched',
        () => (this.isChatchedCustomerData = true)
      )

      // TFICリトライ
      this.requestTficIntervalId = setInterval(() => {
        if (this.isChatchedCustomerData || this.requestTficCount >= this.requestTficLimit) {
          clearInterval(this.requestTficIntervalId)
          Echo.leaveChannel(`store.${this.user.store_user_id}.member.${this.user.id}.form-customer-user.${data.id}`) // Pusher切断
          return
        }

        this.sendTfic(data.id, this.sms.val, this.birthday_num, this.getHasPayment)

        this.requestTficCount++
      }, 5000)

      this.sms.dialog = true
    },
    async sendSms(mobile_phone, birthday, has_payment) {
      return new Promise(async (resolve, reject) => {
        const sendData = {
          mobile_phone,
          birthday,
          has_payment   // 対象年齢の範囲を判別するために活用
        }
        const res = await axios.post('/api/store/create/send-sms', sendData).catch((err) => {
          let message = '送信できませんでした。再度ご確認ください。'
          if (err.response.status === 422) {
            const errors = Object.values(err.response.data).flat()
            if (errors.length) {
              message = errors[0]
            }
          }
          reject(message)
        })

        if (!res) return

        resolve(res.data)
      })
    },
    async sendTfic(customer_user_id, mobile_phone, birthday, has_payment) {
      const sendData = {
        customer_user_id,
        mobile_phone,
        birthday,
        has_payment
      }

      const res = await axios.post('/api/store/create/send-tfic', sendData).catch((err) => {
        if (err.response.status === 422) {
          const errors = Object.values(err.response.data).flat()
          if (errors.length) {
            message = errors[0]
          }
        }

        return false
      })
      if (!res) return

      const data = res.data

      if (data) {
        // ユーザーID Store
        this.updateId(data.id)

        // ユーザー電話番号 Store
        this.updateTel(data.account)

        // ユーザー生年月日 Store
        this.updateBirthday(this.birthday_num)
      }
    },
    async checkCode() {
      // コード未入力
      if (!this.sms.code) {
        this.sms.error_message = '認証コードを必ずご入力してください。'
        return
      }

      const res = await axios
        .post('/api/store/create/check-sms-code', {
          id: this.$store.getters['customer/getId'],
          code: this.sms.code
        })
        .catch((err) => {
          let message = '送信できませんでした。再度ご確認ください。'
          if (err.response.status === 422) {
            const errors = Object.values(err.response.data).flat()
            if (errors.length) {
              message = errors[0]
            }
          }

          this.sms.error_message = message
          return false
        })

      if (!res) return

      if (res.data.error_code === 0) {
        // 最新の申込データ Store
        const userInput = TransUserInputFromTfic(res.data.detail, this.getHasPayment) // データ整形
        this.userInputSetForm(userInput)

        // 既存の申込 口座振替データ Store
        const uploadForm = TransUploadInputFromTfic(res.data.detail) // データ整形
        this.uploadInputSetForm(uploadForm)

        // 顧客区分 Store
        this.updateRefuseFlag(res.data.detail.refuse_flag)

        // 申込ステータスを追加に変更
        const type = res.data.detail.refuse_flag === 3 ? 'new' : 'add' // 断り客の場合、新規申込フォームを表示する。
        this.updateHasRegistration(type)

        // TFIC顧客ID Store
        this.updateLocalCustomerId(res.data.detail.local_customer_id)
      } else {
        // フォーム Store Reset
        this.userInputInitForm()
        this.uploadInputInitForm()
      }
      this.updateHasDoneSms(true)
      this.$emit('next')
    },

    skipCheckCode() {
      // SMS認証スキップ
      this.$confirm('認証コード入力をスキップしますか？', 'スキップ確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'info'
      })
        .then(() => {
          this.updateHasRegistration('new') // 申込ステータスを新規に変更

          this.userInputInitForm() // 個人情報入力 初期化
          this.uploadInputInitForm() // 写真登録入力 初期化

          // 写真登録画面フォーム 本人確認電話関連初期化
          const uploadInputForm = this.uploadInputGetForm
          this.uploadInputSetForm({
            ...uploadInputForm,
            is_beri: true, // 本人確認電話フラグON
            beri_timing: '審査後すぐ',
            beri_at: null
          })

          this.$emit('next')
        })
        .catch(() => {})
    },
    smsClose() {
      this.sms.dialog = false
      this.sms.error_message = ''
      this.sms_count = 0
      this.sms.code = ''
      this.sms.send_error_message = ''
    },
    ...mapActions({
      // 申込ステータス
      updateHasRegistration: 'status/updateHasRegistration',
      // 信販 → 自社割賦 元の信販申込ID
      updateOriginalContractId: 'status/updateOriginalContractId',
      // 申込ステータス
      updateLocalCustomerId: 'status/updateLocalCustomerId',
      // 顧客区分
      updateRefuseFlag: 'status/updateRefuseFlag',
      // ユーザー情報
      updateId: 'customer/updateId',
      updateTel: 'customer/updateTel',
      updateBirthday: 'customer/updateBirthday',
      // SNS
      updateHasDoneSms: 'status/updateHasDoneSms',
      // formの値を設定
      userInputSetForm: 'userInput/setForm',
      userInputInitForm: 'userInput/initForm',
      uploadInputSetForm: 'uploads/setForm',
      uploadInputInitForm: 'uploads/initForm'
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';

.message_area {
  padding: 15px;
  border: 2px solid #eee;
  text-align: center;
}
.sms_input_area {
  margin-left: 100px;
  margin-right: 100px;
}
.error_message {
  margin-top: 10px;
}
.sms {
  text-align: center;
}
.sms__ttl {
  font-size: 25px;
  color: $--color-primary;
}
.sms__icon {
  font-size: 30px;
}
.el-card__header {
  font-size: 18px;
}
.sms__txt {
  font-size: 14px;
}
.sms__form {
  max-width: 148px;
  width: 100%;
  margin: 0 auto;
}
.sms__btn {
  width: 100%;
  margin-top: 20px;
}
.skip__btn {
  width: 100%;
  margin-left: 0;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}
.next {
  margin-top: 20px;
  text-align: center;
  .el-button {
    border-radius: 0;
    padding-left: 30px;
    padding-right: 30px;
  }
}
.input_sample {
  margin: 5px 0;
  font-size: 12px;
  color: salmon;
}
.skip__txt {
  color: salmon;
  text-align: left;
}
</style>
